import { render, staticRenderFns } from "./TextContentCardsStandalone.vue?vue&type=template&id=5e91dfbc"
import script from "./TextContentCardsStandalone.vue?vue&type=script&lang=js"
export * from "./TextContentCardsStandalone.vue?vue&type=script&lang=js"
import style0 from "./TextContentCardsStandalone.vue?vue&type=style&index=0&id=5e91dfbc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports